<p-inputgroup class="w-full">
  <p-inputgroup-addon *ngIf="addonIconClass">
    <i [class]="addonIconClass"></i>
  </p-inputgroup-addon>
  <p-iftalabel class="w-full">
    <p-multiSelect
      [options]="options"
      [(ngModel)]="selectedValues"
      [ngModelOptions]="{ standalone: true }"
      [optionLabel]="'__label'"
      [dataKey]="dataKey"
      [filter]="true"
      [filterBy]="adapter.filterBy || ''"
      [showClear]="showClear"
      [loading]="isLoading"
      [disabled]="disabled"
      [appendTo]="appendTo"
      [styleClass]="styleClass"
      [panelStyleClass]="panelStyleClass"
      [inputId]="inputId"
      [placeholder]="placeholder"
      [emptyMessage]="emptyMessage"
      display="chip"
      (onChange)="onSelectionChange($event.value)"
      (onShow)="onDropdownShow()"
      (onHide)="onDropdownHide()"
    >
      <ng-template pTemplate="item" let-item>
        <div class="flex flex-column">
          <span>{{ getLabel(item) }}</span>
          <small *ngIf="getSecondaryLabel(item)" class="text-600">{{ getSecondaryLabel(item) }}</small>
        </div>
      </ng-template>
      <ng-template pTemplate="filter">
        <p-inputgroup class="w-full" (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input
            #filterInput
            type="text"
            pInputText
            class="w-full"
            [placeholder]="filterPlaceholder"
            autocomplete="off"
            (input)="onFilterInput(filterInput.value)"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
          <span class="filter-loading-indicator" *ngIf="isLoading" aria-live="polite" aria-label="Loading search results">
            <i class="pi pi-spin pi-spinner"></i>
          </span>
          <p-button
            type="button"
            icon="pi pi-times"
            styleClass="p-button-secondary"
            (click)="filterInput.value=''; onFilterInput('')"
          ></p-button>
        </p-inputgroup>
      </ng-template>
    </p-multiSelect>
    <label [for]="inputId">{{ label }}</label>
  </p-iftalabel>
</p-inputgroup>
